const canvasOffset = 24;

export class View {
  constructor(id, renderer, element) {
    this.id = id;
    this.renderer = renderer;
    this.element = element;
    this.element.style.width = "100%";
    this.element.style.height = "100%";
    this.element.oncontextmenu = (event) => {
      event.preventDefault();
      return false;
    };
    this.canvas = document.createElement("canvas");
    this.canvas.style.transform = `translate(${canvasOffset / 2}px, ${
      canvasOffset / 2
    }px)`;
    this.canvas.style.visibility = "hidden";
    this.ctx = this.canvas.getContext("2d");
    this.element.appendChild(this.canvas);
  }

  dispose() {
    if (this.visualisation) {
      this.visualisation.dispose();
      this.element.onmousedown = null;
      this.element.onmouseup = null;
      this.element.onmousemove = null;
      this.element.onmouseleave = null;
    }
  }

  setVisualisation(visualization) {
    if (this.visualisation) {
      this.visualisation.dispose();
    }
    setTimeout(() => {
      this.visualisation = visualization;
      this.visualisation.lookAtScene();
      this.element.onmousedown = (event) => {
        this.visualisation.onMouseDown(event);
      };
      this.element.onmouseup = (event) => {
        this.visualisation.onMouseUp(event);
      };
      this.element.onmousemove = (event) => {
        this.visualisation.onMouseMove(event);
      };
      this.element.onmouseleave = (event) => {
        this.visualisation.onMouseLeave(event);
      };
      this.canvas.style.visibility = "visible";
    }, 0);
  }

  clearVisualisation() {
    if (this.visualisation) {
      this.visualisation.dispose();
      this.element.onmousedown = null;
      this.element.onmouseup = null;
      this.element.onmousemove = null;
      this.element.onmouseleave = null;
    }
    this.visualisation = undefined;
    this.canvas.style.visibility = "hidden";
  }

  render() {
    if (!this.visualisation || !this.element) {
      return;
    }

    const contentScale = this.renderer.getPixelRatio();
    const rect = this.element.getBoundingClientRect();
    const { left, right, top, bottom } = rect;
    const width = rect.width - canvasOffset;
    const height = rect.height - canvasOffset;
    const scaledWidth = width * contentScale;
    const scaledHeight = height * contentScale;
    const rendererCanvas = this.renderer.domElement;
    const isOffscreen =
      bottom < 0 ||
      top > window.innerHeight ||
      right < 0 ||
      left > window.innerWidth ||
      width <= 0 ||
      height <= 0;
    if (!isOffscreen) {
      if (
        rendererCanvas.width < scaledWidth ||
        rendererCanvas.height < scaledHeight
      ) {
        this.renderer.setSize(width, width, false);
      }
      if (
        this.canvas.width !== scaledWidth ||
        this.canvas.height !== scaledHeight
      ) {
        this.canvas.width = scaledWidth;
        this.canvas.height = scaledHeight;
        this.canvas.style.width = `${width}px`;
        this.canvas.style.height = `${height}px`;

        this.visualisation.updateCamera();
      }

      this.visualisation.camera.getWorldDirection(
        this.visualisation.directionalLight.position
      );
      this.visualisation.directionalLight.position.negate();

      this.renderer.setScissor(0, 0, width, height);
      this.renderer.setViewport(0, 0, width, height);
      this.renderer.render(this.visualisation.scene, this.visualisation.camera);

      this.ctx.globalCompositeOperation = "copy";
      this.ctx.drawImage(
        rendererCanvas,
        0,
        rendererCanvas.height - scaledHeight,
        scaledWidth,
        scaledHeight,
        0,
        0,
        scaledWidth,
        scaledHeight
      );
    }
  }
}
